/**
 * Created by lu on 2017/9/13.
 */
var nb = require('../../../nb');
var seriesListWrapper = require('./SeriesList').seriesListWrapper;
var storyLstWrapper = require('./StoryListWrapper').storyLstWrapper;
var Swiper = require('../../../view/Swiper').Swiper;
module.exports = nb.define({
    view: {
        'class': 'content',
        $html:[{
            'class':['banner-swipe',nb.bind('bannerStatus')],
            $html: [{
                $type: Swiper,
                $model: 'bannerSwiper'
            },{
                'class':"loading",
                style:{
                    'text-align':"center"
                },
                $html:{
                    tag:'img',
                    src:'./image/loading.gif'
                }
            }]
        },{
            $type:storyLstWrapper,
            $model:'story'
        },{
            $type: seriesListWrapper,
            $model: ''
        }]
    },
    method: {
        init: function () {

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/Content.js
// module id = 400
// module chunks = 1